import { useCallback } from "react"
import { useDispatch } from "react-redux";
import { clearAccessToken, clearRefreshToken } from "../../utils/localStorageUtils";
import { stopWorkers } from "../../actions/workersActions";
import { setAuth } from "../../actions/authActions";

export const useLogOut = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        clearAccessToken();
        clearRefreshToken();

        dispatch(stopWorkers());
        dispatch(setAuth(false));
    }, [dispatch]);
}